@if (data$ | async; as component) {
  <div class="container" [style]="'background-color :'+ component.background">
    <div class="vertical-selection-container">
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
      @if (isDesktop() | async) {
        @if (items$| async; as items) {
          @switch (items.length) {
            @case (2) {
              <div>
                <cx-carousel
                  [items]="items$ | async"
                  [template]="carouselItem"
                  itemWidth="50%"
                  [animation]="animation"
                  >
                </cx-carousel>
              </div>
            }
            @case (3) {
              <div>
                <cx-carousel
                  [items]="items$ | async"
                  [template]="carouselItem"
                  itemWidth="350px"
                  [animation]="animation"
                  >
                </cx-carousel>
              </div>
            }
          }
        }
      } @else {
        <cx-carousel
          [items]="items$ | async"
          [template]="carouselItem"
          itemWidth="100%"
          [animation]="animation"
          >
        </cx-carousel>
      }
    </div>
  </div>
}

<ng-template #carouselItem let-item="item">
  <app-custom-item-vertical-two-and-three-selection [item]="item"></app-custom-item-vertical-two-and-three-selection>
</ng-template>
